// extracted by mini-css-extract-plugin
export default {"root":"style_root__97VYJ","rightSide":"style_rightSide__2lQYv","leftSide":"style_leftSide__DGM2o"};